export default "__VITE_ASSET__CfTpZ_Je__"